import React, { useEffect, useState } from "react";
import axios from "axios";
import { UserConsumer } from "../../../UserContext";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Link, Redirect, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Table } from "../../../components/CustomPaginations";
import {
	tableStyle,
	dateCol,
	timeCol,
	statusColor,
	TrimString,
} from "../../../components/TableStyle";
import Header from "../../../components/Header";
import "../spOffsiteWorkHours/spOffsiteWorkHours.scss";
import SelectCriteriaForm from "./SelectCriteriaForm";
import { spOffsiteWorkHours_API } from "./spOffsiteWorkHours_API";
import BulkRowActionButtonsBar from "../../../components/BulkRowActionButtonsBar";
import { AlertPopups } from "../../../components/AlertPopups";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { string } from "yup";
import { Col, Row } from "reactstrap";
import ButtonLoader from "../../../components/ButtonLoader";
import { ExcelBtnClassName, ExcelBtnTitle } from "../../ticketModule/variables/ListingVariables";

function SpOffsiteWorkHours() {
	let token,
		joiningDate,
		empDesignation,
		empRole = null;
	let history = useHistory();
	const status = [
		{ value: 0, label: "All" },
		{ value: 1, label: "Pending Requests" },
		{ value: 2, label: "Rejected Requests" },
		{ value: 3, label: "Approved Requests" },
	];
	var months = [
		{ value: 0, label: "All" },
		{ value: 1, label: "January" },
		{ value: 2, label: "February" },
		{ value: 3, label: "March" },
		{ value: 4, label: "April" },
		{ value: 5, label: "May" },
		{ value: 6, label: "June" },
		{ value: 7, label: "July" },
		{ value: 8, label: "August" },
		{ value: 9, label: "September" },
		{ value: 10, label: "October" },
		{ value: 11, label: "November" },
		{ value: 12, label: "December" },
	];

	var date = new Date();
	var currentYear = date.getFullYear();
	const [checkboxSelected, setCheckboxSelected] = useState(false);
	const [rejectSelectedBtnLoad, setRejectSelectedBtnLoad] = useState(false);
	const [approveSelectedBtnLoad, setApproveSelectedBtnLoad] = useState(false);
	const [disableApproveSelectedbtn, setDisableApproveSelectedBtn] =
		useState(true);
	const [disableRejectSelectedbtn, setDisableRejectSelectedBtn] =
		useState(true);
	const [bulkSelectedData, setBulkSelectedData] = useState([]);
	const [pagerData, setPagerData] = useState(null);
	const [yearsList, setYearsList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [apiTokenHeader, setApiTokenHeader] = useState(null);
	const [offsiteReqData, setOffsiteReqData] = useState([]);
	const [requestTypeList, setRequestTypeList] = useState(null);
	const [supervisorsEmpList, setSupervisorsEmpList] = useState(null);
	const [selectedSupEmpList, setSelectedSupEmpList] = useState(null);
	const [selectedStatus, setSelectedStatus] = useState(
		sessionStorage.getItem("SpOffsiteWorkHours")
			? JSON.parse(sessionStorage.getItem("SpOffsiteWorkHours"))[0]
				? JSON.parse(sessionStorage.getItem("SpOffsiteWorkHours"))[0]
				: status[1]
			: status[1]
	);
	const [showBtnLoading, setShowBtnLoading] = useState(false);
	const [selectedTypeList, setSelectedRequestTypeList] = useState(null);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [selectedMonth, setSelectedMonth] = useState(
		sessionStorage.getItem("SpOffsiteWorkHours")
			? JSON.parse(sessionStorage.getItem("SpOffsiteWorkHours"))[3]
				? JSON.parse(sessionStorage.getItem("SpOffsiteWorkHours"))[3]
				: months[0]
			: months[0]
	);
	const [selectedYear, setSelectedYear] = useState(
		sessionStorage.getItem("SpOffsiteWorkHours")
			? JSON.parse(sessionStorage.getItem("SpOffsiteWorkHours"))[4]
				? JSON.parse(sessionStorage.getItem("SpOffsiteWorkHours"))[4]
				: {
						value: currentYear,
						label: currentYear,
				  }
			: {
					value: currentYear,
					label: currentYear,
			  }
	);

	const defaultSorted = [
		{
			dataField: "requestDate",
			order: "desc",
		},
	];
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const getColumns = [
		{
			dataField: "name",
			text: "Name",
			sort: true,
		},
		{
			dataField: "supervisorName",
			text: "Supervisor Name",
			sort: true,
		},
		{
			dataField: "requestDate",
			text: "Worked Date",
			sort: true,
			formatter: dateCol,
		},
		
		{
			dataField: "requestExpiryDate",
			text: "Compensation Expiry Date",
			sort: true,
			formatter: (cell, row) => {
			  if (!row.isApprovedCompensationLog) {
				return "NA"; 
			  } else {
				return dateCol(cell, row); 
			  }
			},
		  },
		{
			dataField: "requestDay",
			text: "Worked Day",
			sort: true
		},
		{
			dataField: "startTime",
			text: "Start Time",
			formatter: timeCol,
			sort: true,
		},
		{
			dataField: "Work Hours",
			text: "Work Hours",
			sort: true,
			formatter: (cell, row) => {
				return row.workingHours + " Hr " + row.workingMinutes + " Min";
			},
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
			formatter: (status) => {
				return status === "Pending"
					? "Pending"
					: status === "InProgress"
					? "Pending"
					: status === "Approved"
					? "Approved"
					: status === "Rejected"
					? "Rejected"
					: "Pending";
			},
			style: statusColor,
		},
		{
			dataField: "workReason",
			text: "Work Reason",
			sort: true,
			formatter: TrimString,
		},
		{
			dataField: "action",
			text: "Action",
			events: {
				onClick: (e) => {
					e.stopPropagation(); // To stop navigation to detail screen
				},
			},
			formatter: (cell, row) => {
				return (
					<div>
						<Link
							to={{
								pathname: `/SpManageOffsiteWorkRequest/${row.id}`,
								state: { requestStatus: row.status },
							}}
						>
							<button className="btnStyle" title="View Detail">
								<FontAwesomeIcon
									id="edit"
									className="hoverEffect"
									icon={faEye}
									size="1x"
								/>
							</button>
						</Link>
					</div>
				);
			},
		},
	];
	useEffect(() => {
		let pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);
		if (empRole.includes("3")) {
			pageSize = GlobalPaginationSize.AdminPaginationSize;
			setNumberOfItemsPerPage(pageSize);
		}

		//To auto start from joining date till current year
		const list = [];
		do {
			list.unshift({ value: joiningDate, label: joiningDate.toString() });
			joiningDate++;
		} while (joiningDate != currentYear + 1);
		setYearsList(list);

		const header = { Authorization: `Bearer ${token}` };
		//get WorkType List
		axios
			.get(`${spOffsiteWorkHours_API.GetWorkType}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const workTypesList = data.workTypes;
					workTypesList.unshift({ value: 0, label: "All" });
					if (sessionStorage.getItem("SpOffsiteWorkHours")) {
						if (
							JSON.parse(
								sessionStorage.getItem("SpOffsiteWorkHours")
							)[1] != null
						)
							setSelectedRequestTypeList(
								JSON.parse(
									sessionStorage.getItem("SpOffsiteWorkHours")
								)[1]
							);
						else setSelectedRequestTypeList(workTypesList[0]);
					} else setSelectedRequestTypeList(workTypesList[0]);

					setRequestTypeList(
						workTypesList.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
				}
			});
		//get Supervisors Emp List
		axios
			.get(`${spOffsiteWorkHours_API.GetSupervisorsEmployeeNameList}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					if (sessionStorage.getItem("SpOffsiteWorkHours")) {
						if (
							JSON.parse(
								sessionStorage.getItem("SpOffsiteWorkHours")
							)[2] != null
						)
							setSelectedSupEmpList(
								JSON.parse(
									sessionStorage.getItem("SpOffsiteWorkHours")
								)[2]
							);
						else setSelectedSupEmpList({ value: 0, label: "All" });
					} else setSelectedSupEmpList({ value: 0, label: "All" });

					const supEmpList = data.map((obj) => {
						return { value: obj.employeeId, label: obj.name };
					});
					let sorted = supEmpList.sort((a, b) =>
						a.label.localeCompare(b.label)
					);
					sorted.unshift({ value: 0, label: "All" });
					setSupervisorsEmpList(sorted);
				}
			});

		getOffsiteRequests(pageSize);
		setApiTokenHeader(header);
	}, []);

	const getOffsiteRequests = (pageSize) => {
		//get default Table pagination Data
		axios
			.get(
				`${
					spOffsiteWorkHours_API.GetDefaultEmployeeOffsiteRequests
				}&PageSize=${
					pageSize ? pageSize : numberOfItemsPerPage
				}&SortBy=${sortBy.dataField}_${sortBy.order}&Status=${
					selectedStatus.value
				}&Month=${selectedMonth.value}&Year=${selectedYear.value}
				&EmployeeId=${
					sessionStorage.getItem("SpOffsiteWorkHours")
						? JSON.parse(
								sessionStorage.getItem("SpOffsiteWorkHours")
						  )[2]
							? JSON.parse(
									sessionStorage.getItem("SpOffsiteWorkHours")
							  )[2].value
							: 0
						: 0
				}
				&Type=${
					sessionStorage.getItem("SpOffsiteWorkHours")
						? JSON.parse(
								sessionStorage.getItem("SpOffsiteWorkHours")
						  )[1]
							? JSON.parse(
									sessionStorage.getItem("SpOffsiteWorkHours")
							  )[1].value
							: 0
						: 0
				}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setOffsiteReqData(res.data.requests);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	};

	const updateTableData = (status, type, employee, month, year) => {
		
		setIsLoading(true);
		axios
			.get(
				`${
					spOffsiteWorkHours_API.GetEmployeeOffsiteRequestsPagination
				}?PageSize=${numberOfItemsPerPage}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${
					sortBy.order
				}&Status=${status}&Type=${type}&Month=${month}&Year=${year}&EmployeeId=${employee}`,
				{
					headers: apiTokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setOffsiteReqData(res.data.requests);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${
					spOffsiteWorkHours_API.GetEmployeeOffsiteRequestsPagination
				}?PageNumber=${1}&PageSize=${PageSize}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}&Status=${selectedStatus.value}&Month=${
					selectedMonth.value
				}&Year=${selectedYear.value}`,
				{
					headers: apiTokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setOffsiteReqData(res.data.requests);
				}
			});
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${
				spOffsiteWorkHours_API.GetEmployeeOffsiteRequestsPagination
			}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}
			&EmployeeId=${
				sessionStorage.getItem("SpOffsiteWorkHours")
					? JSON.parse(
							sessionStorage.getItem("SpOffsiteWorkHours")
					  )[2]
						? JSON.parse(
								sessionStorage.getItem("SpOffsiteWorkHours")
						  )[2].value
						: 0
					: 0
			}
			&Type=${
				sessionStorage.getItem("SpOffsiteWorkHours")
					? JSON.parse(
							sessionStorage.getItem("SpOffsiteWorkHours")
					  )[1]
						? JSON.parse(
								sessionStorage.getItem("SpOffsiteWorkHours")
						  )[1].value
						: 0
					: 0
			}
			&SortBy=${sortField}_${sortOrder}&Status=${selectedStatus.value}&Month=${
				selectedMonth.value
			}&Year=${selectedYear.value}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${
				spOffsiteWorkHours_API.GetEmployeeOffsiteRequestsPagination
			}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}
			&EmployeeId=${
				sessionStorage.getItem("SpOffsiteWorkHours")
					? JSON.parse(
							sessionStorage.getItem("SpOffsiteWorkHours")
					  )[2]
						? JSON.parse(
								sessionStorage.getItem("SpOffsiteWorkHours")
						  )[2].value
						: 0
					: 0
			}
			&Type=${
				sessionStorage.getItem("SpOffsiteWorkHours")
					? JSON.parse(
							sessionStorage.getItem("SpOffsiteWorkHours")
					  )[1]
						? JSON.parse(
								sessionStorage.getItem("SpOffsiteWorkHours")
						  )[1].value
						: 0
					: 0
			}&SortBy=${sortBy.dataField}_${sortBy.order}&Status=${
				selectedStatus.value
			}&Month=${selectedMonth.value}&Year=${selectedYear.value}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: apiTokenHeader,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setOffsiteReqData(res.data.requests);
					}
				});
		}
	};
	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (sessionStorage.getItem("SpOffsiteWorkHours"))
			obj = JSON.parse(sessionStorage.getItem("SpOffsiteWorkHours"));
		if (property === "status") obj[0] = value;
		else if (property === "type") obj[1] = value;
		else if (property === "employee") obj[2] = value;
		else if (property === "month") obj[3] = value;
		else if (property === "year") obj[4] = value;
		sessionStorage.setItem("SpOffsiteWorkHours", JSON.stringify(obj));
	};
	const rowEvents = {
		onClick: (e, row) => {
			history.push({
				pathname: `/SpManageOffsiteWorkRequest/${row.id}`,
				state: { requestStatus: row.status },
			});
		},
	};
	function getNonSelectableRows(rows) {
		return rows.filter((r) => r.status != "Pending").map((r) => r.id);
	}
	const selectRow = {
		mode: "checkbox",
		clickToSelect: true,
		nonSelectable: getNonSelectableRows(offsiteReqData),
		onSelect: (row, isSelect, rowIndex, e) => {
			let bulkData = [];
			bulkData = bulkSelectedData;

			if (isSelect) {
				setDisableRejectSelectedBtn(false);
				setDisableApproveSelectedBtn(false);
				bulkData.push(row);
				setBulkSelectedData(bulkData);
				//	return true;
			} else {
				bulkData = bulkData.filter(function (item) {
					return item.id !== row.id;
				});
				setBulkSelectedData(bulkData);
				if (bulkData.length === 0) {
					setDisableRejectSelectedBtn(true);
					setDisableApproveSelectedBtn(true);
					setBulkSelectedData([]);
				}
			}
			setCheckboxSelected(!checkboxSelected);
		},
		onSelectAll: (isSelect, rows, e) => {
			setDisableRejectSelectedBtn(!disableRejectSelectedbtn);
			setDisableApproveSelectedBtn(!disableApproveSelectedbtn);
			setCheckboxSelected(!checkboxSelected);
			if (isSelect) {
				if (rows.length === 0) {
					setDisableRejectSelectedBtn(true);
					setDisableApproveSelectedBtn(true);
				}
				setBulkSelectedData(rows);
			} else {
				setBulkSelectedData([]);
				setDisableRejectSelectedBtn(true);
				setDisableApproveSelectedBtn(true);
			}
		},
	};
	const onApproveSelectedbtnClick = () => {
		setDisableRejectSelectedBtn(true);
		setCheckboxSelected(true);
		setApproveSelectedBtnLoad(true);
		let idList = bulkSelectedData.map((item) => item.id);

		//api call
		let body = {
			id: idList,
			approvalStatus: 3, //approve
		};
		axios
			.patch(
				`${spOffsiteWorkHours_API.ApproveRejectBulkApplications}`,
				body,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setApproveSelectedBtnLoad(false);
					setDisableRejectSelectedBtn(true);
					setDisableApproveSelectedBtn(true);
					AlertPopups.successAlert.fire({
						text: "Application(s) Approved",
					});
					getOffsiteRequests();
					setBulkSelectedData([]);
				}
			});
	};
	const onRejectSelectedbtnClick = () => {
		setDisableApproveSelectedBtn(true);
		setCheckboxSelected(true);
		setRejectSelectedBtnLoad(true);
		let idList = bulkSelectedData.map((item) => item.id);
		//api call
		let body = {
			id: idList,
			approvalStatus: 2, //reject
		};
		axios
			.patch(
				`${spOffsiteWorkHours_API.ApproveRejectBulkApplications}`,
				body,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setRejectSelectedBtnLoad(false);
					setDisableApproveSelectedBtn(true);
					setDisableRejectSelectedBtn(true);
					AlertPopups.successAlert.fire({
						text: "Application(s) Rejected",
					});
					getOffsiteRequests();
					setBulkSelectedData([]);
				}
			});
	};
	const exportToExcel = () => {
		setShowBtnLoading(true);
		
		axios
			.get(
				`${
					spOffsiteWorkHours_API.ExportToExcel
				}?Status=${selectedStatus.value}&Type=${selectedTypeList.value}&Month=${selectedMonth.value}&Year=${selectedYear.value}&EmployeeId=${selectedSupEmpList.value}`,
				{
					headers: apiTokenHeader,
					responseType: 'blob', // Specify response type as blob
				}
			)
			.then((response) => {
				const url = URL.createObjectURL(response.data);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute(
					"download",
					"Employees Offsite Work Request.xlsx"
				);
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch(() => {
				setShowBtnLoading(false);
			});
	};
	
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empRole = userDetails.empRole;
				empDesignation = userDetails.designation;
				joiningDate = userDetails.empJoinedOn.split("-")[0];
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header title="Offsite Work Request" />
							<hr />
							<SelectCriteriaForm
								status={status.sort((a, b) =>
									a.label.localeCompare(b.label)
								)}
								selectedStatus={selectedStatus}
								onStatusChange={(value) => {
									setSelectedStatus(value);
									storeFiltersStates(value, "status");
									updateTableData(
										value.value,
										selectedTypeList.value,
										selectedSupEmpList.value,
										selectedMonth.value,
										selectedYear.value
									);
								}}
								requestTypeList={requestTypeList}
								selectedReqType={selectedTypeList}
								onRequestTypeChange={(value) => {
									setSelectedRequestTypeList(value);
									storeFiltersStates(value, "type");
									updateTableData(
										selectedStatus.value,
										value.value,
										selectedSupEmpList.value,
										selectedMonth.value,
										selectedYear.value
									);
								}}
								months={months}
								selectedMonth={selectedMonth}
								onMonthChange={(value) => {
									setSelectedMonth(value);
									storeFiltersStates(value, "month");
									updateTableData(
										selectedStatus.value,
										selectedTypeList.value,
										selectedSupEmpList.value,
										value.value,
										selectedYear.value
									);
								}}
								years={yearsList}
								selectedYear={selectedYear}
								onYearChange={(value) => {
									setSelectedYear(value);
									storeFiltersStates(value, "year");
									updateTableData(
										selectedStatus.value,
										selectedTypeList.value,
										selectedSupEmpList.value,
										selectedMonth.value,
										value.value
									);
								}}
								supervisorsEmpList={supervisorsEmpList}
								selectedSupEmpList={selectedSupEmpList}
								onSupEmpChange={(value) => {
									setSelectedSupEmpList(value);
									storeFiltersStates(value, "employee");
									updateTableData(
										selectedStatus.value,
										selectedTypeList.value,
										value.value,
										selectedMonth.value,
										selectedYear.value
									);
								}}
							/>
					<Row>
								<Col className="d-flex justify-content-end">
									<ButtonLoader
										className={ExcelBtnClassName}
										onClick={exportToExcel}
										disabled={
											!offsiteReqData.length ||
											showBtnLoading
										}
										btnTitle={ExcelBtnTitle}
										showBtnLoading={showBtnLoading}
									/>
								</Col>
							</Row>
							{pagerData ? (
								<>
									{/* 
									
									 Backend Required, Commented for Now
									 
									<BulkRowActionButtonsBar
										checkboxSelected={checkboxSelected}
										onApproveSelectedbtnClick={
											onApproveSelectedbtnClick
										}
										disableApproveSelectedbtn={
											disableApproveSelectedbtn
										}
										onRejectSelectedbtnClick={
											onRejectSelectedbtnClick
										}
										disableRejectSelectedbtn={
											disableRejectSelectedbtn
										}
										rejectSelectedBtnLoad={
											rejectSelectedBtnLoad
										}
										approveSelectedBtnLoad={
											approveSelectedBtnLoad
										}
									/> */}
									<PaginationProvider
										pagination={paginationFactory({
											custom: true,
											totalSize: offsiteReqData.length,
											page: pagerData.CurrentPage,
											sizePerPage: pagerData.PageSize,
											paginationSize: pagerData.PageSize,
										})}
									>
										{({
											paginationProps,
											paginationTableProps,
										}) => {
											
											return (
												<Table
													inputValue={""}
													keyField={"id"}
													columns={getColumns}
													items={offsiteReqData}
													tableStyle={tableStyle}
													paginationProps={
														paginationProps
													}
													paginationTableProps={
														paginationTableProps
													}
													onTablePageChange={
														handleTableChange
													}
													defaultSorted={
														defaultSorted
													}
													showFeedback={false}
													tableLoader={isLoading}
													SearchBar={() => {
														return null;
													}}
													pagerData={pagerData}
													receiveData={(
														pageNumber,
														PageSize
													) => {
														receiveData(
															pageNumber,
															PageSize
														);
													}}
													adminPagination={
														userDetails.empRole.includes(
															"3"
														)
															? true
															: false
													}
													rowEvents={rowEvents}
													striped={false}
													hover={true}
													condensed={true}
													//selectRow={selectRow} // Backend Required, Commented for Now
												/>
											);
										}}
									</PaginationProvider>
								</>
							) : null}
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default SpOffsiteWorkHours;
